import { Injectable } from '@angular/core';
import { i18nService } from '../../services/i18n.service';

@Injectable()
export class AmountInputService {
  private DECIMAL_SEPARATOR: string = '.';
  private THOUSANDS_SEPARATOR: string = ',';
  private fractionSize: number = 2;

  constructor(public _i18n: i18nService) {}

  getLocaleSeparators() {
    const value = parseFloat('12345').toLocaleString(this._i18n.getSelectedLanguage(), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    this.setDecimalSeparator(value.substr(value.length - 3, 1));
    this.setThousandsSeparator(value.substr(2, 1));
  }

  getDecimalSeparator() {
    return this.DECIMAL_SEPARATOR;
  }

  getThousandsSeparator() {
    return this.THOUSANDS_SEPARATOR;
  }

  setDecimalSeparator(separator: string) {
    this.DECIMAL_SEPARATOR = separator;
  }

  setThousandsSeparator(separator: string) {
    this.THOUSANDS_SEPARATOR = separator;
  }

  getFractionSize() {
    return this.fractionSize;
  }

  setFractionSize(size: number) {
    this.fractionSize = size;
  }
}
